import { combineReducers } from 'redux'

import { authProviderReducer } from '../../containers/AuthProvider'
import { claimsReducer } from '../../containers/Claims'
import { snackbarProviderReducer } from '../../containers/SnackbarProvider'

/**
 * Reducers configuration.
 * Combines all reducers into a single root reducer.
 */
export const rootReducer = combineReducers({
  authProvider: authProviderReducer,
  claims: claimsReducer,
  snackbarProvider: snackbarProviderReducer
})
